import styled from "styled-components";

export const ChartContainer = styled.div``;

export const ChartDisableHover = styled.div`
    height: 400px;
    margin: 0 0 -400px 0;
    background-color:transparent;
    position: relative;
    z-index: 3;
`;

export const ChartSubtitle = styled.i`
    font-size: 15px;
    display: block;
    text-align: right;
    padding: 0 30px 10px;
`;